// @flow
import * as React from 'react';
import { createStore as createReduxStore, combineReducers, applyMiddleware, compose } from 'redux';
import type { Store } from 'redux';
import getGeneratorMiddleware from './generator.middleware.js';
import clearMessagesMiddleware from '../modules/ui/clear-messages.middleware.js';
import * as UIReducers from '../modules/ui/ui.reducers.js';

// Inline redux-thunk implementation — added for new React pages that use                                                                      
  // `createAsyncThunk` from RTK. Legacy generator middleware doesn't handle
  // function-actions; this 1-liner does. Identical to upstream redux-thunk.                                                                     
  const thunk = ({ dispatch, getState }) => next => action =>                                                                                    
    typeof action === 'function' ? action(dispatch, getState) : next(action);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function createStore(
  initialState: Object,
  reducers: Object
): Store<ReduxState, Action, Dispatch<Yield<*>>> {
  const store = createReduxStore(
    combineReducers({
      ...UIReducers,
      ...reducers
    }),
    initialState,
    composeEnhancers(applyMiddleware(thunk, getGeneratorMiddleware(), clearMessagesMiddleware))
  );

  if (module.hot && typeof module.hot.accept === 'function') {
    module.hot.accept(reducers, () => {
      store.replaceReducer(combineReducers(reducers));
    });
  }

  return store;
}
